import { render, staticRenderFns } from "./TopBlock.vue?vue&type=template&id=78d43c0e&scoped=true"
import script from "./TopBlock.vue?vue&type=script&lang=js"
export * from "./TopBlock.vue?vue&type=script&lang=js"
import style0 from "./TopBlock.vue?vue&type=style&index=0&id=78d43c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d43c0e",
  null
  
)

export default component.exports